import { useQuery } from '@tanstack/react-query';

import axios from 'src/lib/axios';
import { QueryConfig } from 'src/lib/react-query';
import { formatResourcePath } from 'src/utils/regex';
import { BillingEntity } from 'src/features/billingEntity/utils/types';
import { STORAGE_PREFIX } from 'src/config';

const RESOURCE = `${STORAGE_PREFIX}/:parkingId/billing/billing-entities/:entityId/`;

type QueryFnType = typeof queryFn;

interface DTO {
    parkingId: string;
    entityId: string;
}
const queryFn = ({ parkingId, entityId }: DTO): Promise<BillingEntity> => {
    return axios.get(formatResourcePath(RESOURCE, { parkingId, entityId }));
};

interface UseQueryHookOptions extends DTO {
    config?: QueryConfig<QueryFnType>;
}
const useQueryHook = ({ config, ...payload }: UseQueryHookOptions) =>
    useQuery({
        queryKey: [RESOURCE, payload],
        queryFn: async () => await queryFn(payload),
        ...config,
    });

export { useQueryHook as useGetBillingEntity };
